var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-5 py-3"},[_c('h3',[_vm._v("Secondary Names")]),(_vm.names.length === 0)?[_c('span',[_vm._v("No names")])]:_vm._l((_vm.names),function(name,i){return _c('v-row',{key:i},[_c('v-col',[_c('v-text-field',{attrs:{"value":name.description,"label":"Secondary name","readonly":""}})],1)],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }